/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Tb_Step_1_TitleInputs */

const en_mk_tb_step_1_title = /** @type {(inputs: Mk_Tb_Step_1_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Assign a person and a reviewer`)
};

const id_mk_tb_step_1_title = /** @type {(inputs: Mk_Tb_Step_1_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tentukan penanggung jawab dan reviewer`)
};

/**
* | output |
* | --- |
* | "Assign a person and a reviewer" |
*
* @param {Mk_Tb_Step_1_TitleInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_tb_step_1_title = /** @type {((inputs?: Mk_Tb_Step_1_TitleInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Tb_Step_1_TitleInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_tb_step_1_title(inputs)
	return en_mk_tb_step_1_title(inputs)
});